import { Component, OnInit } from '@angular/core';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AppSettings } from 'read-appsettings-json';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressBarModule } from 'primeng/progressbar';
import { Router } from '@angular/router';
import { UserService } from '../../../Services/Admin/UserServices';
import { CheckAuth } from '../../../Services/UtilityService';

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.css']
})
export class AdminLoginComponent implements OnInit {
  tokenKey: string = "";
  appModel: any;
  loginForm: FormGroup;
  userID: number;
  constructor(private _fb: FormBuilder, private router: Router, private UserService: UserService, private checkAuth: CheckAuth) {        
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
    this.userID = 0;
    this.loginForm = this._fb.group({
      userid: 0,
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    })
  }
  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }
  successMessage: any;
  isshowsuccess: boolean;
  errorMessage: any;
  isshowerror: boolean;
  isShowprogressSpinner: boolean;
  blockedPanel: boolean = false;
  blockedDocument: boolean = false;
  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }
  showerror(msg) {
    this.errorMessage = msg;
    this.isshowerror = true;
    this.isshowsuccess = false;
    window.scrollTo(0, 0);
  }
  hideerror() {
    this.errorMessage = "";
    this.isshowerror = false;
  }
  showsuccess(msg) {
    this.successMessage = msg;
    this.isshowsuccess = true;
    this.isshowerror = false;
    window.scrollTo(0, 0);
  }
  ngOnInit() {
    this.appModel = AppSettings.Current().ConnectionStrings;
    this.isshowerror = false;
    this.isShowprogressSpinner = false;
    sessionStorage.setItem('BaseURL', this.appModel.BaseURL);
    this.tokenKey = sessionStorage.getItem('tokenValue');
  }

  login(): void {
    debugger;
    if (!this.loginForm.valid) {
      return;
    }
    this.tokenKey = sessionStorage.getItem('tokenValue');
    if (this.tokenKey == null || this.tokenKey == undefined) {
      this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
      this.showerror("Token expired. Please try again.");
      this.unblockDocument();
    }
    this.blockDocument();    
    this.UserService.GetUserInformationbyUsername(this.tokenKey, this.loginForm.value.username, this.loginForm.value.password).subscribe(
      data => {
        debugger;
        if (data["status"] == "Success") {
          if (data["userMaster"] != null) {
            if (data["userMaster"].length > 0) {
              sessionStorage.setItem('AdminUserId', "" + this.ecryption(data["userMaster"][0].userId));
              this.router.navigate(['admin/admin-dashboard']);
            } else {
              this.showerror("Invalid login details, Please check username and password are correct.");
              this.unblockDocument();
            }
          }
          else {
            this.showerror(data["message"]);
            this.unblockDocument();
          } 
        }
        else {
          this.showerror(data["message"]);
          this.unblockDocument();
        }        
      },
      errorCode => {
        this.showerror(errorCode);
        this.unblockDocument();
      }
    );

    //this.authService.blrlogin(this.loginForm.value.username, this.loginForm.value.password).subscribe(result => {
    //  debugger;
    //  if (result) {
    //    if (typeof (result) !== 'undefined' && (result) !== null) {
    //      try {
    //        //let a = result.json();
    //        if (result.user != undefined) {
              
    //        }
    //        else {
    //          this.showerror(result._body);
    //          this.unblockDocument();
    //        }
    //      } catch (e) {
    //        this.showerror(result._body);
    //        this.unblockDocument();
    //      }
    //    }
    //  }
    //  else {
    //    this.showerror("There is an error with login API call. Please try again later.");
    //    this.unblockDocument();
    //  }
    //});

  }

  ecryption(plaintext): Promise<string> {
    //return this.encryptionService.generateKey('passphrase').then(key => {
    //  return this.encryptionService.encrypt(plaintext, key);
    //});
    return plaintext;
  }
  GetplainText(encryptedtext): Promise<string> {
    if (encryptedtext != null) {
      //return this.encryptionService.generateKey('passphrase').then(key => {
      //  return this.encryptionService.decrypt(encryptedtext, key);
      //});
      return encryptedtext;
    } else {
      this.router.navigate(['/admin/login']);
    }
  }

  get username() { return this.loginForm.get('username'); }
  get password() { return this.loginForm.get('password'); }
}
